export const VIBO_REFRESH_TOKEN_KEY = 'x-refresh-token';
export const VIBO_TOKEN_KEY = 'x-token';
export const DEVICE_KEY = 'device';
